// 떠 있는 좌측 패널 열기 버튼 — 모바일 전용(레일이 0폭이라 안쪽 토글에 손이 안 닿는다).
//
// 표시 여부는 CSS 가 정한다(.side-reopen.collapsed). 인라인 style 로 강제하면
// 미디어쿼리를 이기지 못해 데스크톱에서 레일 토글과 아이콘이 둘로 보였다.
//
// 셸(.shell) 밖·.chat-root 직속이라, 모바일에서 사이드바가 숨겨져도 살아남는다.
//
// 아이콘은 햄버거(lucide menu) — 이 버튼은 모바일에서만 보이고, 모바일에서
// '패널 접힘' 글리프는 데스크톱 은유라 낯설다(Bishop 제보). GPT·Claude 앱처럼
// 메뉴로 읽히게 한다. 데스크톱의 접기/펴기는 레일 안 토글이 그대로 담당한다.
export default function SideReopen({ collapsed, onOpen }: {
  collapsed: boolean;
  onOpen: () => void;
}) {
  return (
    <button
      className={`side-reopen${collapsed ? " collapsed" : ""}`}
      type="button"
      title="메뉴 열기"
      aria-label="메뉴 열기"
      onClick={onOpen}
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 6h16" />
        <path d="M4 12h16" />
        <path d="M4 18h16" />
      </svg>
    </button>
  );
}
